//---------------without redux-persist-----------------
// DataProvider.js
// import React, { createContext, useEffect, useState } from "react";
// import { fetchCollectionsData } from "./fetchData";

// // Create a context to share data between components
// export const DataContext = createContext();

// const DataProvider = ({ children }) => {

//   const [homeImprovementData, setHomeImprovementData] = useState([]);
//   const [electronicCollectionData, setElectronicCollectionData] = useState([]);
//   const [loading, setLoading] = useState(true); // Initial loading state for first 5 products
//   const [loadingMore, setLoadingMore] = useState(false); // To handle background loading of next products
//   const [lastHomeImprovementDoc, setLastHomeImprovementDoc] = useState(null);
//   const [lastElectronicCollectionDoc, setLastElectronicCollectionDoc] = useState(null);

//   useEffect(() => {
//     const fetchInitialData = async () => {
//       const { homeImprovementData, electronicCollectionData, lastHomeImprovementDoc, lastElectronicCollectionDoc } = await fetchCollectionsData();
//       setHomeImprovementData(homeImprovementData);
//       setElectronicCollectionData(electronicCollectionData);
//       setLastHomeImprovementDoc(lastHomeImprovementDoc);
//       setLastElectronicCollectionDoc(lastElectronicCollectionDoc);
//       setLoading(false); // Set loading to false once the first set of products is loaded
//       loadMoreHomeImprovement();  // Start loading next products in the background
//       loadMoreElectronicCollection(); // Start loading next products in the background
//     };

//     fetchInitialData();
//   }, []);

//   // Function to load more products for home improvement with a delay
//   const loadMoreHomeImprovement = async () => {
//     if (lastHomeImprovementDoc && !loadingMore) {
//       setLoadingMore(true); // Set loadingMore true to prevent multiple fetches
//       setTimeout(async () => {
        
//         const { homeImprovementData, lastHomeImprovementDoc: newLastHomeImprovementDoc } = await fetchCollectionsData(lastHomeImprovementDoc);


//         setHomeImprovementData((prevData) => [...prevData, ...homeImprovementData]);
//         console.log(homeImprovementData)
//         setLastHomeImprovementDoc(newLastHomeImprovementDoc);
//         setLoadingMore(false); // Set loadingMore false after the data is loaded
//       }, 0); // Delay of 0 seconds
//     }
//   };


//   // Function to load more products for electronic collection with a delay
//   const loadMoreElectronicCollection = async () => {
//     if (lastElectronicCollectionDoc && !loadingMore) {
//       setLoadingMore(true); // Set loadingMore true to prevent multiple fetches
//       setTimeout(async () => {
//         const { electronicCollectionData, lastElectronicCollectionDoc: newLastElectronicCollectionDoc } = await fetchCollectionsData(lastElectronicCollectionDoc);
//         setElectronicCollectionData((prevData) => [...prevData, ...electronicCollectionData]);
//         setLastElectronicCollectionDoc(newLastElectronicCollectionDoc);
//         setLoadingMore(false); // Set loadingMore false after the data is loaded
//       }, 0); // Delay of 0 seconds
//     }
//   };

 

//   return (
//     <DataContext.Provider value={{
//       homeImprovementData,
//       electronicCollectionData,
//       loading,
//       loadingMore,
//       loadMoreHomeImprovement,
//       loadMoreElectronicCollection,
//     }}>
//       {children}
//     </DataContext.Provider>
//   );
// };

// export default DataProvider;





//-------------with redux-persist------
// DataProvider.js
import React, { createContext, useEffect, useState } from "react";
import { fetchCollectionsData } from "./fetchData";


import { homeImprovementRequest, electronicCollectionRequest, topCollectionRequest, ourCollectionRequest } from "../redux/slice/dataFetch";
import { store } from "../redux/store";
import { useDispatch } from "react-redux";

// Create a context to share data between components
export const DataContext = createContext();

const DataProvider = ({ children }) => {

  const dispatch = useDispatch();


  const [homeImprovementData, setHomeImprovementData] = useState([]);
  const [electronicCollectionData, setElectronicCollectionData] = useState([]);
  const [topCollectionData, setTopCollectionData] = useState([]);
  const [ourCollectionData, setOurCollectionData] = useState([]);
  const [loading, setLoading] = useState(true); // Initial loading state for first 5 products
  const [loadingMore, setLoadingMore] = useState(false); // To handle background loading of next products
  const [lastHomeImprovementDoc, setLastHomeImprovementDoc] = useState(null);
  const [lastElectronicCollectionDoc, setLastElectronicCollectionDoc] = useState(null);
  const [lastTopCollectionDoc, setLastTopCollectionDoc] = useState(null);
  const [lastOurCollectionDoc, setLastOurCollectionDoc] = useState(null);
  

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true); // *Set loading to true before fetching
      const { homeImprovementData, electronicCollectionData, topCollectionData, ourCollectionData, lastHomeImprovementDoc, lastElectronicCollectionDoc, lastTopCollectionDoc, lastOurCollectionDoc } = await fetchCollectionsData();
      
      // *Update Redux state
      dispatch(homeImprovementRequest({ homeImprovement: homeImprovementData }));
      dispatch(electronicCollectionRequest({ electronicCollection: electronicCollectionData }));
      dispatch(topCollectionRequest({ topCollection: topCollectionData }));
      dispatch(ourCollectionRequest({ ourCollection: ourCollectionData }));
      // *Update Redux state

      setHomeImprovementData(homeImprovementData);
      setElectronicCollectionData(electronicCollectionData);
      setTopCollectionData(topCollectionData);
      setOurCollectionData(ourCollectionData);
      setLastHomeImprovementDoc(lastHomeImprovementDoc);
      setLastElectronicCollectionDoc(lastElectronicCollectionDoc);
      setLastTopCollectionDoc(lastTopCollectionDoc);
      setLastOurCollectionDoc(lastOurCollectionDoc);
      setLoading(false); // Set loading to false once the first set of products is loaded
      loadMoreHomeImprovement();  // *Start loading next products in the background
      loadMoreElectronicCollection(); // *Start loading next products in the background
      loadMoreTopCollection(); //*
      loadMoreOurCollection(); //*
      
    };

    fetchInitialData();
  }, [dispatch]); //*
  // }, []); //*


// Function to load more products for home improvement
// const loadMoreHomeImprovement = async () => {
//   if (lastHomeImprovementDoc && !loadingMore) {
//     setLoadingMore(true); // Set loadingMore to true before fetching
//     setTimeout(async () => {
//       const { homeImprovementData, lastHomeImprovementDoc: newLastHomeImprovementDoc } = await fetchCollectionsData(lastHomeImprovementDoc);

//       // Update Redux state
//       dispatch(homeImprovementRequest({ homeImprovement: [...homeImprovementData, ...homeImprovementData] }));

//       // Update local state
//       setHomeImprovementData((prevData) => [...prevData, ...homeImprovementData]);
//       setLastHomeImprovementDoc(newLastHomeImprovementDoc);
//       setLoadingMore(false); // Set loadingMore to false after fetching
//     }, 1000); // 1 second delay
//   }
// };


  // Function to load more products for home improvement with a delay
  const loadMoreHomeImprovement = async () => {
    if (lastHomeImprovementDoc && !loadingMore) {
      setLoadingMore(true); // Set loadingMore true to prevent multiple fetches
      setTimeout(async () => {
        
        const { homeImprovementData, lastHomeImprovementDoc: newLastHomeImprovementDoc } = await fetchCollectionsData(lastHomeImprovementDoc);

 // Update the state first
 setHomeImprovementData((prevData) => {
  const updatedData = [...prevData, ...homeImprovementData];

  // Dispatch to Redux after the state is updated
  store.dispatch(
    homeImprovementRequest({
      homeImprovement: updatedData,
    })
  );

  return updatedData; // Ensure state is updated
});

setLastHomeImprovementDoc(newLastHomeImprovementDoc);
setLoadingMore(false); // Set loadingMore false after the data is loaded
}, 1000); // Delay of 2 seconds
}
};







  // Function to load more products for electronic collection with a delay
  const loadMoreElectronicCollection = async () => {
    if (lastElectronicCollectionDoc && !loadingMore) {
      setLoadingMore(true); // Set loadingMore true to prevent multiple fetches
      setTimeout(async () => {
        const { electronicCollectionData, lastElectronicCollectionDoc: newLastElectronicCollectionDoc } = await fetchCollectionsData(lastElectronicCollectionDoc);

  setElectronicCollectionData((prevData) => {
  const updatedData = [...prevData, ...electronicCollectionData];

  // Dispatch to Redux after the state is updated
  store.dispatch(
    electronicCollectionRequest({
      electronicCollection: updatedData,
    })
  );

  return updatedData; // Ensure state is updated
});

setLastElectronicCollectionDoc(newLastElectronicCollectionDoc);
setLoadingMore(false); // Set loadingMore false after the data is loaded
}, 1000); // Delay of 2 seconds
}
};



// Function to load more products for top collection with a delay
const loadMoreTopCollection = async () => {
  if (lastTopCollectionDoc && !loadingMore) {
    setLoadingMore(true); // Set loadingMore true to prevent multiple fetches
    setTimeout(async () => {
      const { topCollectionData, lastTopCollectionDoc: newLastTopCollectionDoc } = await fetchCollectionsData(lastTopCollectionDoc);

setTopCollectionData((prevData) => {
const updatedData = [...prevData, ...topCollectionData];
console.log(topCollectionData)
// Dispatch to Redux after the state is updated
store.dispatch(
  topCollectionRequest({
    topCollection: updatedData,
  })
);

return updatedData; // Ensure state is updated
});

setLastTopCollectionDoc(newLastTopCollectionDoc);
setLoadingMore(false); // Set loadingMore false after the data is loaded
}, 1000); // Delay of 2 seconds
}
};

// Function to load more products for our collection with a delay
const loadMoreOurCollection = async () => {
  if (lastOurCollectionDoc && !loadingMore) {
    setLoadingMore(true); // Set loadingMore true to prevent multiple fetches
    setTimeout(async () => {
      const { ourCollectionData, lastOurCollectionDoc: newLastOurCollectionDoc } = await fetchCollectionsData(lastOurCollectionDoc);
setOurCollectionData((prevData) => {
  const updatedData = [...prevData, ...ourCollectionData];
// Dispatch to Redux after the state is updated
store.dispatch(
  ourCollectionRequest({
    ourCollection: updatedData,
  })
);

return updatedData; // Ensure state is updated
});

setLastOurCollectionDoc(newLastOurCollectionDoc);
setLoadingMore(false); // Set loadingMore false after the data is loaded
}, 1000); // Delay of 2 seconds
}
};




  return (
    <DataContext.Provider value={{
      homeImprovementData,
      electronicCollectionData,
      topCollectionData,
      ourCollectionData,
      loading,
      loadingMore,
      loadMoreHomeImprovement,
      loadMoreElectronicCollection,
      loadMoreTopCollection,
      loadMoreOurCollection,

    }}>
      {children}
    </DataContext.Provider>
  );
};

export default DataProvider;